import React from 'react';
import styled from 'styled-components';
import Faq from './Faq';

const FaqSecStyle = styled.section`
  h2 {
    color: black;
    text-align: center;
    padding: 50px 15%;
  }

  max-width: 1100px;
  margin: 20px auto;
`;

export default function FaqSection({ faqdata, title }) {
  return (
    <FaqSecStyle>
      <h2>{title}</h2>
      <Faq faqs={faqdata} />
    </FaqSecStyle>
  );
}
